enum RejectButtonMode {
  Reject,
  RequestChanges,
}

export default RejectButtonMode;
